export default {
    'secao': {
        // 'key': 'value',
    },
};